/** 常量数据 **/

export const COOKIE_KEY_LANGUAGE = 'CurrentLanguage'; // 本地语言

export const LOCAL_STORE_USER_INFO = 'user-info';

/** 存储字典的常量 */
export const DICT_STORE_KEY = 'dict_store_key';

/** 存储查询条件的KEY的常量 */
export const QUERY_FORM_DATA_KEY = 'query_form_data_key';

/** 是否动态数据 */
export const COOKIE_KEY_STATUS = 'currentStatus'; // 本地语言

/** 新版Portal跳转URL配置 */
export const NEW_PORTAL_URLS = {
	production: 'https://global-supplier.tencent.com/collaboration/home/homePage',
	test: 'https://test-global-supplier.tencent.com/collaboration/home/homePage'
};
